import Head from "next/head";
import style from "./ClientError.module.scss";
import DashboardLayout from "@/components/page-modules/dashboard/DashboardLayout";
import { FC } from "react";
interface ClientErrorProps {
  onTryAgain: () => void;
}
const ClientError: FC<ClientErrorProps> = ({
  onTryAgain
}) => {
  return <DashboardLayout button={"hide"} show="hide" data-sentry-element="DashboardLayout" data-sentry-component="ClientError" data-sentry-source-file="ClientError.tsx">
      <Head data-sentry-element="Head" data-sentry-source-file="ClientError.tsx">
        <title>Client Error</title>
      </Head>
      <div className={style.wrapper}>
        <div className={style.box}>
          <h1 className={style.title}>Oops, something went wrong on your end</h1>
          <p className={style.des}>We're sorry for the inconvenience. Please try again later.</p>
          <button className={style.btn} onClick={onTryAgain}>
            Try Again
          </button>
        </div>
      </div>
    </DashboardLayout>;
};
export default ClientError;